import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { faNumber } from 'utils/common.util';
import fa from 'locales/fa.json';
import request from 'services/request';
import { UserScoresUrl } from 'services/routes';
import { SModal } from 'components/Account/style';
import { Skeleton, Spin, Table, Tooltip } from 'antd';
import AntButton from 'components/Common/AntButton';
import { InfoCircleOutlined } from '@ant-design/icons';

const Scores: React.FC = () => {
  const user = useSelector((state) => state.account.user);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [page, setPage] = useState(1);

  const handleClick = async (): Promise<boolean> => {
    setLoading(true);
    const res: any = await request.get(UserScoresUrl()); // eslint-disable-line
    setLoading(false);
    if (res.ok) {
      setOpen(true);
      setList([...list, ...res.data.data]);
      return true;
    }
    return null;
  };

  const handleLoadMore = async (): Promise<void> => {
    setPageLoading(true);
    const res: any = await request.get(UserScoresUrl(page + 1)); // eslint-disable-line
    setPageLoading(false);
    res.ok && setPage(page + 1);
    res.ok && setList([...list, ...res.data.data]);
  };

  const dataSource = list.map((item, index) => ({
    row: faNumber(index + 1),
    department: item.description,
    title: item.type,
    count: faNumber(item.value),
  }));

  const columns = ['row', 'title', 'department', 'count'].map((item) => ({
    title: fa.global[item],
    dataIndex: item,
  }));

  return (
    <div>
      <div className="flex justify-between">
        <div
          onClick={handleClick}
          className="text-[16px] mb-3 hover:text-blue-0 cursor-pointer"
        >
          {fa.global.hasanat}{' '}
          <span className="text-[12px]">({fa.account.seeScores})</span>{' '}
          <Spin spinning={loading} />
        </div>

        <div>{faNumber(Number(user.fake_rate).toLocaleString())} </div>
      </div>

      <SModal
        centered
        title={null}
        footer={null}
        width={900}
        destroyOnClose
        open={open}
        onCancel={(): void => (setOpen(false), setList([]), setPage(1))}
      >
        <div className="flex flex-col w-full self-start">
          <div className="self-center text-blue-13 font-bold text-[18px]">
            {fa.account.scoresList}{' '}
            <Tooltip
              overlayStyle={{ maxWidth: '500px', fontSize: '14px' }}
              color="geekblue"
              title={
                <div>
                  <div>{faNumber(fa.account.scores.info1)}</div>
                  <div className="mt-[8px]">{fa.account.scores.info2}</div>
                  <div>{faNumber(fa.account.scores.info3)}</div>
                  <div>{faNumber(fa.account.scores.info4)}</div>
                  <div>{fa.account.scores.info5}</div>
                  <div>{fa.account.scores.info6}</div>
                </div>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>{' '}
          </div>
          <div className="flex flex-col  p-[16px] text-[16px]">
            <Table dataSource={dataSource} columns={columns} pagination={false} />
          </div>

          {list.length === 20 * page && (
            <div className="w-full px-[30px] text-center my-[30px]">
              {pageLoading ? (
                <Skeleton active />
              ) : (
                <AntButton width="200px" onClick={handleLoadMore}>
                  {fa.course.loadMore}
                </AntButton>
              )}
            </div>
          )}
        </div>
      </SModal>
    </div>
  );
};

export default Scores;
